import { render, staticRenderFns } from "./Investmens.vue?vue&type=template&id=4b8810b0&"
import script from "./Investmens.vue?vue&type=script&lang=js&"
export * from "./Investmens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports